import { LayoutGrid } from '@music-vine/cadence/icons';
import type { ZoneLink } from '../MusicZones/components/zonesNavigation';
import { Backgrounds } from './icons/backgrounds';
import { Buttons } from './icons/buttons';
import { Characters } from './icons/characters';
import { Cinematic } from './icons/cinematic';
import { Creator } from './icons/creator';
import { Doodles } from './icons/doodles';
import { Elements } from './icons/elements';
import { Emojis } from './icons/emojis';
import { Glitch } from './icons/glitch';
import { Infographics } from './icons/infographics';
import { Intros } from './icons/intros';
import { Logos } from './icons/logos';
import { LowerThirds } from './icons/lower-thirds';
import { Notifications } from './icons/notifications';
import { Overlays } from './icons/overlays';
import { Promos } from './icons/promos';
import { Reactions } from './icons/reactions';
import { Slideshows } from './icons/slideshows';
import { Socials } from './icons/socials';
import { Subscribe } from './icons/subscribe';
import { TextAndType } from './icons/text-and-type';
import { Titles } from './icons/titles';
import { Transitions } from './icons/transitions';
import { Vfx } from './icons/vfx';
import { Vintage } from './icons/vintage';
export const MG_ZONE_LINKS: ZoneLink[] = [{
  slug: 'featured',
  name: 'Featured',
  href: '/motion-graphics',
  icon: LayoutGrid
}, {
  slug: 'creator',
  name: 'Creator',
  href: '/motion-graphics/category/creator',
  icon: Creator
}, {
  slug: 'intros',
  name: 'Intros',
  href: '/motion-graphics/category/intros',
  icon: Intros
}, {
  slug: 'transitions',
  name: 'Transitions',
  href: '/motion-graphics/category/transitions',
  icon: Transitions
}, {
  slug: 'overlays',
  name: 'Overlays',
  href: '/motion-graphics/category/overlays',
  icon: Overlays
}, {
  slug: 'text-and-type',
  name: 'Text & type',
  href: '/motion-graphics/category/text-and-type',
  icon: TextAndType
}, {
  slug: 'titles',
  name: 'Titles',
  href: '/motion-graphics/category/titles',
  icon: Titles
}, {
  slug: 'subscribe-buttons',
  name: 'Subscribe',
  href: '/motion-graphics/category/buttons/social-media/subscribe-buttons',
  icon: Subscribe
}, {
  slug: 'vfx',
  name: 'VFX',
  href: '/motion-graphics/category/vfx',
  icon: Vfx
}, {
  slug: 'lower-thirds',
  name: 'Lower thirds',
  href: '/motion-graphics/category/lower-thirds',
  icon: LowerThirds
}, {
  slug: 'logos',
  name: 'Logos',
  href: '/motion-graphics/category/logos',
  icon: Logos
}, {
  slug: 'elements',
  name: 'Elements',
  href: '/motion-graphics/category/elements',
  icon: Elements
}, {
  slug: 'infographics',
  name: 'Infographics',
  href: '/motion-graphics/category/infographics',
  icon: Infographics
}, {
  slug: 'characters-and-objects',
  name: 'Characters',
  href: '/motion-graphics/category/characters-and-objects',
  icon: Characters
}, {
  slug: 'social-media',
  name: 'Socials',
  href: '/motion-graphics/category/social-media',
  icon: Socials
}, {
  slug: 'backgrounds',
  name: 'Backgrounds',
  href: '/motion-graphics/category/backgrounds',
  icon: Backgrounds
}, {
  slug: 'promos',
  name: 'Promos',
  href: '/motion-graphics/category/promos',
  icon: Promos
}, {
  slug: 'shapes-and-doodles',
  name: 'Doodles',
  href: '/motion-graphics/category/shapes-and-doodles',
  icon: Doodles
}, {
  slug: 'slideshows',
  name: 'Slideshows',
  href: '/motion-graphics/category/slideshows',
  icon: Slideshows
}, {
  slug: 'notifications-and-pop-ups',
  name: 'Notifications',
  href: '/motion-graphics/category/notifications-and-pop-ups',
  icon: Notifications
}, {
  slug: 'emojis-and-icons',
  name: 'Emojis',
  href: '/motion-graphics/category/emojis-and-icons',
  icon: Emojis
}, {
  slug: 'buttons',
  name: 'Buttons',
  href: '/motion-graphics/category/buttons',
  icon: Buttons
}, {
  slug: 'reactions',
  name: 'Reactions',
  href: '/motion-graphics/category/reactions',
  icon: Reactions
}, {
  slug: 'cinematic',
  name: 'Cinematic',
  href: '/motion-graphics/category/cinematic',
  icon: Cinematic
}, {
  slug: 'vintage',
  name: 'Vintage',
  href: '/motion-graphics/category/vintage',
  icon: Vintage
}, {
  slug: 'glitch',
  name: 'Glitch',
  href: '/motion-graphics/category/glitch',
  icon: Glitch
}];